import React from 'react';
import ContainerTemplate from '../../../../widgets/template/Container';
import SuscripcionesView from './SuscripcionesView';
import * as ROUTES from '../../../../router/Routes';

const SuscripcionesModule = () => {
  return (
    <ContainerTemplate active={ROUTES.suscripciones} routes={[ROUTES.root]}>
      <SuscripcionesView />
    </ContainerTemplate>
  );
};

export default SuscripcionesModule;
